import { colorsPalettes } from "@similarweb/styles";
import { Button, Dropdown, EllipsisDropdownItem } from "@similarweb/ui-components";

import { useTopicsContext } from "app/pages/activation/context/Topics/TopicsContext";
import { useTopicsDataContext } from "app/pages/activation/context/Topics/TopicsDataContext";
import { translate } from "app/filters/i18nFilter";

import { sortingKeys } from "../automationKeys";
import { SORT_ITEMS } from "../constants";
import { SORT_LABEL } from "../texts";

import * as SC from "./styles";

export const Sorting = () => {
    const { onSort: onClick } = useTopicsContext();
    const { isDisabled, sorting: selectedSorting } = useTopicsDataContext();

    return (
        <SC.SortWrapper
            data-automation={sortingKeys.container}
            isDisabled={isDisabled}
            className="sortingWrapper"
        >
            <Dropdown
                appendTo=".sortingWrapper"
                selectedIds={{ [selectedSorting?.id]: true }}
                dropdownPopupPlacement="bottom"
                onClick={onClick}
            >
                {[
                    <Button
                        key="btn"
                        type="flatDark"
                    >
                        <SC.Text>{translate(SORT_LABEL, { sort: translate(selectedSorting?.text) })}</SC.Text>
                        <SC.SortIcon
                            iconName="arrow-down-grey"
                            size="xs"
                            iconColor={colorsPalettes.carbon[500]}
                        />
                    </Button>,
                    ...SORT_ITEMS.map(({ id, text }) => {
                        return (
                            <EllipsisDropdownItem
                                key={id}
                                id={id}
                            >
                                {translate(text)}
                            </EllipsisDropdownItem>
                        );
                    }),
                ]}
            </Dropdown>
        </SC.SortWrapper>
    );
};
